// extracted by mini-css-extract-plugin
export default {"holePillH1":"HolePill_holePillH1__0mXRy","holePillH10":"HolePill_holePillH10__dfqHT"};